import { KomboJob } from '../types/komboJob';

// Stable sort — preserves upstream Kombo ordering within each group.
export const sortKomboJobsConnectedToBottom = (
  jobs: KomboJob[],
  isConnected: (job: KomboJob) => boolean
): KomboJob[] =>
  [...jobs].sort((a, b) => {
    const aConnected = isConnected(a);
    const bConnected = isConnected(b);
    if (aConnected === bConnected) return 0;
    return aConnected ? 1 : -1;
  });
